import axios from 'axios'

let unauthorizedHandler

export const registerUnauthorizedHandler = ( handler ) => {
  unauthorizedHandler = handler
}

const STAGE_DOMAIN = 'https://stage-lms.alive.university'
const IS_PROD = false
const IS_STAGE = true

export const API_BASE_URL = IS_PROD ? `https://resume-api.alive.university/placements/api/v1/placement` : IS_STAGE ? `${STAGE_DOMAIN}/placements/api/v1/placement` : 'http://localhost:5800/api/v1/placement'
export const EXAM_API_BASE_URL = IS_PROD ? `https://exam-api.alive.university/api/v2` : `${STAGE_DOMAIN}/api/v2/exam`
export const PRACTICE_API_BASE_URL = IS_PROD ? `https://resume-api.alive.university/placements/api/v1/placement` : `${STAGE_DOMAIN}/placements/api/v1/placement/practice`
export const ASSESSMENTS_API_BASE_URL = IS_PROD ? `https://resume-api.alive.university/placements/api/v1/placement` : `${STAGE_DOMAIN}/placements/api/v1/placement/assessment`
export const ALIVE_CORE_API_BASE_URL = IS_PROD ? 'https://alive-core-api.alive.university/api/v2' : IS_STAGE ? `${STAGE_DOMAIN}/api/v2/core` : `http://localhost:5500/api/v2`

export const apiClient = axios.create( {
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
} )

apiClient.interceptors.request.use( ( config ) => {
  const token = localStorage.getItem( 'id_token' )

  if ( config.data instanceof FormData ) {
    delete config.headers['Content-Type']
  }

  if ( token ) config.headers.Authorization = `Bearer ${token}`
  return config
}, ( error ) => Promise.reject( error ) )

apiClient.interceptors.response.use(
  ( response ) => response,
  ( error ) => {

    if ( !error.request.responseURL.endsWith( 'all-languages' ) )
      console.log( error )

    if ( error.response?.status === 401 ) {
      unauthorizedHandler?.()
    }
    return Promise.reject( error )
  }
)

export const createAPIClient = ( options = {} ) => {
  const apiClient = axios.create( {
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
    ...options
  } )

  apiClient.interceptors.request.use( ( config ) => {
    const token = localStorage.getItem( 'id_token' )

    if ( config.data instanceof FormData ) {
      delete config.headers['Content-Type']
    }

    if ( token ) config.headers.Authorization = `Bearer ${token}`
    return config
  }, ( error ) => Promise.reject( error ) )

  apiClient.interceptors.response.use(
    ( response ) => response,
    ( error ) => {

      if ( !error.request.responseURL.endsWith( 'all-languages' ) )
        console.log( error )

      if ( error.response?.status === 401 ) {
        unauthorizedHandler?.()
      }
      return Promise.reject( error )
    }
  )

  return apiClient
}

export const practiceApiClient = createAPIClient( {
  baseURL: PRACTICE_API_BASE_URL,
} )

export const coreApiClient = createAPIClient( {
  baseURL: ALIVE_CORE_API_BASE_URL
} )

export default apiClient
